import { Link } from 'react-router-dom';
import { ArrowRight, BadgeCheck, Building2, Clock3, ShieldCheck, Users } from 'lucide-react';
import CtaBand from '@/components/CtaBand';
import FaqList from '@/components/FaqList';
import JsonLd from '@/components/JsonLd';
import Seo from '@/components/Seo';
import { WhatsAppIcon } from '@/components/Layout';
import { followerBands, niches, steps, testimonials } from '@/lib/content';
import { faqSchema, localBusinessSchema, organizationSchema } from '@/lib/schema';
import { ANALYTICS_IMAGE, HERO_IMAGE, WA_CATALOG, WA_DEFAULT, waLink } from '@/lib/site';

const reasons = [
{
  icon: Users,
  title: 'Seguidores reais e orgânicos',
  text: 'Perfis que cresceram com conteúdo. Sem pacote de seguidores fantasma, sem inflar número para fechar negócio.'
},
{
  icon: Building2,
  title: 'Empresa registrada em BH',
  text: 'Muita Mídia LTDA, CNPJ 51.781.940/0001-04, sede na Avenida Afonso Pena, 3355, Sala 1101, Serra.'
},
{
  icon: ShieldCheck,
  title: 'Perfis verificados antes da venda',
  text: 'Conferimos crescimento, amostra da base, idade da conta e sinais de risco antes de oferecer o perfil.'
},
{
  icon: BadgeCheck,
  title: 'Suporte humano no WhatsApp',
  text: 'Você fala com especialista, não com robô. Da escolha do nicho até a autenticação em dois fatores.'
},
{
  icon: Clock3,
  title: 'Mais de 5 anos de mercado',
  text: 'Operação contínua desde 2019, com mais de 7.000 clientes e 8.400 perfis vendidos em todo o Brasil.'
}];


export default function Home() {
  return (
    <>
      <Seo />
      <JsonLd data={[organizationSchema, localBusinessSchema, faqSchema]} />

      <section className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-0 grid-noise opacity-40" />
        <div className="absolute inset-x-0 top-0 h-px hairline" />
        <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 pb-16 pt-12 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:pb-24 lg:pt-16">
          <div>
            <p className="text-[11px] uppercase tracking-[0.28em] text-orange-300/90">
              Comprar perfil Instagram · Belo Horizonte
            </p>
            <h1 className="mt-4 max-w-xl font-display text-[2.15rem] leading-[1.12] text-white sm:text-5xl lg:text-[3.35rem]">
              Compre seu perfil no Instagram com seguidores reais e orgânicos
            </h1>
            <p className="mt-5 max-w-lg text-[15px] leading-relaxed text-white/65">
              A Muita Mídia vende perfis nichados do Instagram desde 2019: mais de 7.000 clientes atendidos e mais de 8.400 perfis vendidos, de 1k a 900k seguidores, com transferência assistida e CNPJ verificado.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href={WA_DEFAULT}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-5 py-3 text-sm font-semibold text-[#070b14]">

                <WhatsAppIcon className="h-4 w-4" />
                Falar com especialista no WhatsApp
              </a>
              






            </div>
          </div>
          <div className="relative">
            <div className="absolute -left-8 -top-8 h-40 w-40 rounded-full bg-fuchsia-500/20 blur-3xl" />
            <div className="absolute -bottom-10 -right-6 h-48 w-48 rounded-full bg-orange-500/20 blur-3xl" />
            <figure className="relative overflow-hidden rounded-[28px] border border-white/10 bg-[#0c1220] shadow-[0_40px_80px_rgba(0,0,0,0.45)]">
              <img
                src={HERO_IMAGE}
                alt="Smartphone com feed do Instagram iluminando uma mesa em escritório noturno, representando a compra de perfil Instagram"
                className="h-[340px] w-full object-cover sm:h-[420px]"
                width={1600}
                height={900} />

              <figcaption className="absolute bottom-4 left-4 right-4 flex items-center justify-between rounded-2xl border border-white/10 bg-[#070b14]/80 px-4 py-3 backdrop-blur">
                <span className="text-xs text-white/70">Perfis de 1k a 900k · nichados</span>
                <span className="text-xs font-medium text-orange-200">Seguidores reais</span>
              </figcaption>
            </figure>
          </div>
        </div>
      </section>

      <div className="border-y border-white/10 bg-[#0a101c]">
        <p className="mx-auto max-w-6xl px-4 py-4 text-center text-[12px] uppercase tracking-[0.18em] text-white/55 sm:px-6 sm:text-[13px]">
          Desde 2019 · +7.000 clientes · +8.400 perfis vendidos · CNPJ verificado
        </p>
      </div>

      <section className="mx-auto max-w-6xl px-4 py-20 sm:px-6">
        <div className="mb-10 flex items-end justify-between gap-6">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-orange-300/80">Processo</p>
            <h2 className="mt-2 font-display text-3xl text-white sm:text-4xl">Como funciona a venda de perfis Instagram</h2>
          </div>
          


        </div>
        <ol className="grid gap-4 md:grid-cols-4">
          {steps.map((step) =>
          <li key={step.n} className="rounded-2xl border border-white/10 bg-[#0c1220] p-5">
              <span className="font-display text-2xl text-orange-300">{step.n}</span>
              <h3 className="mt-3 text-base font-semibold text-white">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/55">{step.text}</p>
            </li>
          )}
        </ol>
      </section>

      <section className="border-y border-white/10 bg-[#080d18]">
        <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 py-20 sm:px-6 lg:grid-cols-2">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-orange-300/80">Por que a Muita Mídia</p>
            <h2 className="mt-2 font-display text-3xl text-white sm:text-4xl">Comprar página Instagram com empresa, não com intermediário</h2>
            <p className="mt-4 text-sm leading-relaxed text-white/60">
              Quem busca perfil Instagram à venda precisa de método: CNPJ, contrato, curadoria e alguém do outro lado do WhatsApp depois que o Pix cai. É isso que fazemos em Belo Horizonte desde 2019.
            </p>
            <ul className="mt-8 space-y-5">
              {reasons.map((item) =>
              <li key={item.title} className="flex gap-4">
                  <span className="mt-0.5 grid h-10 w-10 shrink-0 place-items-center rounded-full border border-white/10 bg-white/5 text-orange-200">
                    <item.icon className="h-4 w-4" />
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-white">{item.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-white/55">{item.text}</p>
                  </div>
                </li>
              )}
            </ul>
          </div>
          <figure className="overflow-hidden rounded-[28px] border border-white/10">
            <img
              src={ANALYTICS_IMAGE}
              alt="Mãos analisando métricas de seguidores em um perfil do Instagram no celular"
              className="h-full w-full object-cover"
              width={800}
              height={1000} />

          </figure>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-20 sm:px-6">
        <p className="text-[11px] uppercase tracking-[0.22em] text-orange-300/80">Catálogo</p>
        <h2 className="mt-2 font-display text-3xl text-white sm:text-4xl">Nichos disponíveis para comprar perfil no Instagram</h2>
        <p className="mt-3 max-w-2xl text-sm text-white/55">
          Humor, moda, finanças, fitness, gastronomia, viagens, pets, games, beleza, motivacional, marketing, entretenimento, futebol, cortes e outros. O nicho certo vale mais do que um número inflado na bio.
        </p>
        <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
          {niches.map((niche) =>
          <a
            key={niche.slug}
            href={waLink(
              `Olá, Muita Mídia. Tenho interesse em perfis do nicho de ${niche.name}. Podem me enviar as opções disponíveis?`
            )}
            target="_blank"
            rel="noopener noreferrer"
            className="group rounded-2xl border border-white/10 bg-[#0c1220] p-4 transition hover:border-orange-300/40">

              <h3 className="text-sm font-semibold text-white">{niche.name}</h3>
              <p className="mt-2 text-xs leading-relaxed text-white/50">{niche.blurb}</p>
            </a>
          )}
        </div>
      </section>

      <section className="border-y border-white/10 bg-[#0a101c]">
        <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6">
          <h2 className="font-display text-3xl text-white sm:text-4xl">Faixas de seguidores — de 1k a 900k</h2>
          <p className="mt-3 max-w-2xl text-sm text-white/55">
            Perfil Instagram à venda em cinco faixas, para quem está testando um nicho ou comprando um ativo grande.
          </p>
          <div className="mt-10 grid gap-4 md:grid-cols-5">
            {followerBands.map((band) =>
            <a
              key={band.slug}
              href={waLink(
                `Olá, Muita Mídia. Tenho interesse em perfis na faixa de ${band.label} seguidores. Podem me enviar as opções disponíveis?`
              )}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-2xl border border-white/10 bg-[#070b14] p-5 hover:border-fuchsia-300/30">

                <p className="ig-text font-display text-2xl">{band.label}</p>
                <h3 className="mt-3 text-sm font-semibold text-white">{band.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-white/50">{band.text}</p>
              </a>
            )}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-20 sm:px-6">
        <h2 className="font-display text-3xl text-white sm:text-4xl">Quem já comprou perfil Instagram conosco</h2>
        <p className="mt-3 max-w-2xl text-sm text-white/55">
          Recortes de clientes reais — nomes e cidades como registrados no atendimento, com o nicho adquirido.
        </p>
        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((item) =>
          <blockquote key={item.name} className="flex flex-col rounded-2xl border border-white/10 bg-[#0c1220] p-6">
              <p className="text-sm leading-relaxed text-white/70">“{item.quote}”</p>
              <footer className="mt-6 border-t border-white/10 pt-4">
                <p className="text-sm font-semibold text-white">{item.name}</p>
                <p className="text-xs text-white/45">{item.city} · {item.niche}</p>
              </footer>
            </blockquote>
          )}
        </div>
      </section>

      <section className="border-t border-white/10 bg-[#080d18]">
        <div className="mx-auto max-w-3xl px-4 py-20 sm:px-6">
          <h2 className="font-display text-3xl text-white sm:text-4xl">Perguntas frequentes sobre comprar perfil Instagram</h2>
          <p className="mt-3 text-sm text-white/55">
            Segurança, prazo, pagamento, contrato e o que acontece depois da transferência.
          </p>
          <div className="mt-8">
            <FaqList />
          </div>
        </div>
      </section>

      <CtaBand />
      <p className="sr-only">
        <a href={WA_CATALOG}>Catálogo no WhatsApp</a>
      </p>
    </>);

}